import ContentReader from "./components/content-reader/content-reader";
export default ContentReader;
